(function ($) {
  var $document = $(document);
  $document.ready(function () {
    var priceSqM = Number($('[name="price_sqm"]').val());
    $document.on('change', '.field-1sqm', function () {
      var lengthSqM = $('.block-field-in').find('.field-1sqm:checked').length;
      var priceTotal = lengthSqM * priceSqM;
      $('.block-score .sq-m').text(lengthSqM);
      $('.block-score .price').text(priceTotal);
      $('[name="sq_m"]').val(lengthSqM);
      $('[name="order_total"]').val(priceTotal);
    });
    $('.sponsor-app-form').submit(function (e) {
      e.preventDefault();
      if (formOrderValidation($(this))) {
        place_order();
      }
    });
    $('.form-sponsoring select').customSelect({
      placeholder: 'Anrede'
    });
    $('.box-row-junior input[type="checkbox"]').click(function () {
      if ($(this).is(':checked')) {
        $(this).closest('.box-row-junior').find('.box-col-junior').addClass('is-show');
      } else {
        $(this).closest('.box-row-junior').find('.box-col-junior').removeClass('is-show');
      }
    });
    $('.link-form-sponsoring').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
    });
    get_field_sponsors();
  });
  function formOrderValidation($form) {
    var valid = true;
    var checkedSqm = false;
    $form.find('.not-valid, .error-message').remove();
    $form.find('input[aria-required="true"]:visible').each(function () {
      if (!$(this).val() || $(this).attr('type') == 'checkbox' && !$(this).is(':checked')) {
        $(this).attr('aria-invalid', true);
        valid = false;
        $(this).parents('.box-col').eq(0).append('<span class="not-valid">Dies ist ein Pflichtfeld.</span>');
      } else {
        $(this).attr('aria-invalid', false);
      }
      if ($(this).attr('type') == 'email') {
        if (!is_email($(this).val())) {
          $(this).attr('aria-invalid', true);
          valid = false;
          if (!$(this).parents('.box-col').eq(0).find('.not-valid').length) {
            $(this).parents('.box-col').eq(0).append('<span class="not-valid">Die eingegebene E-Mail-Adresse ist ungültig.</span>');
          }
        } else {
          $(this).attr('aria-invalid', false);
          $(this).parents('.box-col').eq(0).find('.not-valid').remove();
        }
      }
    });
    $form.find('select[aria-required="true"]').each(function () {
      if (!$(this).val()) {
        $(this).attr('aria-invalid', true);
        valid = false;
        $(this).parents('.box-col').eq(0).append('<span class="not-valid">Dies ist ein Pflichtfeld.</span>');
      } else {
        $(this).attr('aria-invalid', false);
      }
    });
    if (!$('.field-sponsoring').find('.field-1sqm:checked').length) {
      alert('Bitte wählen Sie einen Platz aus!');
      valid = false;
    }
    if (!valid) {
      $form.append('<div class="error-message">Ein oder mehrere Felder weisen einen Fehler auf. Bitte überprüfe das und versuche es erneut.</div>');
      $form.addClass('invalid');
    } else {
      $form.removeClass('invalid');
    }
    return valid;
  }
  function place_order() {
    var $form = $('.sponsor-app-form');
    var formData = $form.serialize();
    var orderItems = [];
    var paymentService = $form.find('[name="payment_service"]').val();
    var $action = 'place_order';
    if (paymentService == 'payrexx') {
      $action = 'place_order_payrexx';
    }
    $('.field-sponsoring .field-1sqm:checked').each(function () {
      var item = {
        id: $(this).val()
      };
      orderItems.push(item);
    });
    var data = {
      action: $action,
      orderItems: orderItems,
      orderData: formData
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {
        $('.loader-sponsoring').show();
      },
      success: function success(data) {
        if (!data.status) {
          $form.append('<div class="error-message">' + data.message + '</div>');
          $form.addClass('invalid');
          $('.loader-sponsoring').hide();
        } else {
          if (data.javascriptUrl.length) {
            if (paymentService == 'payrexx') {
              window.location.href = data.javascriptUrl;
            }
            if (paymentService == 'wallee') {
              $('body').append('<script src="' + data.javascriptUrl + '"></' + 'script>');
              setTimeout(function () {
                window.LightboxCheckoutHandler.startPayment(null, function () {
                  console.log('An error occurred during the initialization of the payment lightbox.');
                });
              }, 1000);
            }
          }
        }
        setTimeout(function () {
          $('.loader-sponsoring').hide();
        }, 3000);
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }
  function get_field_sponsors() {
    var $form = $('.sponsor-app-form');
    var page_id = $form.find('[name="page_id"]').val();
    var data = {
      action: 'get_field_sponsors',
      page_id: page_id
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function beforeSend(xhr) {
        $('.loader-sponsoring').show();
        $('.field-sponsoring .block-field-wrap').css('opacity', 0);
      },
      success: function success(data) {
        if (data.contents.length) {
          var contentHtml = data.contents.map(function (obj, i) {
            return obj.content;
          });
          var $items = $(contentHtml.join(''));
          $('.field-sponsoring').find('.block-field-in').append($items);
          $('.block-field').attr('style', $('#sizeparent').val());
          init_tooltipster();
        }
        $('.loader-sponsoring').hide();
        $('.field-sponsoring .block-field-wrap').css('opacity', 1);
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }
  function init_tooltipster() {
    $('.field-sponsoring .is-booked').tooltipster({
      contentAsHTML: true,
      position: 'bottom-left',
      offsetY: -12,
      arrow: false
      //trigger: 'click',
    });
  }

  function is_email(email) {
    var $reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if ($reg.test(email)) {
      return true;
    }
    return false;
  }
})(jQuery);